import hdapi from "./hdapi";
const fs = require("fs");

/**
 * @param {string} str
 */
export function encodeURI(str) {
	return (str + "")
		.replace(/%/g, "%25")
		.replace(/=/g, "%3D")
		.replace(/\?/g, "%3F")
		.replace(/\+/g, "%2B")
		.replace(/&/g, "%26");
}
/**
 * @return {string}
 */
export function encodeQuery(data) {
	var ss = [];
	for (var k in data) {
		var v = data[k];
		if (v == null) continue;
		if (typeof v === "object") v = JSON.stringify(v);
		ss.push(encodeURI(k) + "=" + encodeURI(v));
	}
	return ss.join("&");
}
/**
 * @param {string} str
 */
export function decodeQuery(str) {
	var data = {};
	if (!str) return data;
	var ss = str.split("&");
	for (var i = 0; i < ss.length; i++) {
		var s = ss[i].split("=");
		if (s.length != 2) continue;
		var k = decodeURIComponent(s[0]);
		var v = decodeURIComponent(s[1]);
		if (/^\[{/.test(v))
			try {
				v = JSON.parse(v);
			} catch (e) {}
		data[k] = v;
	}
	return data;
}

/**
 * 获取距离1970-01-05(星期1)的天数
 * @param {Date|number} date
 */
export function getDay(date) {
	getDay.t = getDay.t || new Date("1970-01-05 00:00").getTime();
	return Math.floor((+date - getDay.t) / 86400e3);
}

/**
 * 格式化时间显示
 * @param {string} format
 * @param {number|Date} t
 */
export function format(format, t) {
	t = new Date(t);
	if (!format) {
		let now = new Date();
		if (getDay(now) - getDay(t) == 1) format = "昨天 hh:mm";
		else if (t.getFullYear() != now.getFullYear()) format = "YYYY-MM-DD hh:mm";
		else if (t.getMonth() != now.getMonth() || t.getDate() != now.getDate()) format = "MM-DD hh:mm";
		else format = "hh:mm";
	}
	var Y = (t.getFullYear() + 1e4).toString().slice(1);
	return format
		.replace(/YYYY/g, Y)
		.replace(/YY/g, Y.slice(2))
		.replace(/MM/g, (t.getMonth() + 101).toString().slice(1))
		.replace(/DD/g, (t.getDate() + 100).toString().slice(1))
		.replace(/hh/g, (t.getHours() + 100).toString().slice(1))
		.replace(/mm/g, (t.getMinutes() + 100).toString().slice(1))
		.replace(/ss/g, (t.getSeconds() + 100).toString().slice(1));
}

/**
 * 用v初始化def, 第一层只保留def结构，之后会复制v结构
 * @template T
 * @param {T} def
 * @param {any} v
 * @param {boolean} [dynamic]
 * @returns {T}
 */
export function deepInit(def, v, dynamic) {
	if (Array.isArray(def) && !Array.isArray(v)) return def;
	if (typeof def != typeof v) return def;
	if (def == null) return v;
	if (typeof def === "object") {
		for (let k in def) {
			def[k] = deepInit(def[k], v[k], true);
			delete v[k];
		}
		if (dynamic)
			for (let k in v) {
				def[k] = v[k];
			}
		return def;
	}
	return v;
}

/**
 * /foo/bar -> /foo
 * @param {string} url
 */
export function dirname(url) {
	for (var i = url.length - 1; i >= 0; i--) {
		if (url[i] == "/" || url[i] == "\\") return url.slice(0, i);
	}
	return "";
}

/**
 * @param {string} filename
 */
export function extname(filename) {
	var type = filename.split(".");
	return type[type.length - 1];
}

/**
 * 调整src高宽，类似css中的background-size: contain
 * @param {Size} src
 * @param {Size} dst
 */
export function contain(src, dst) {
	try {
		var r = src.width / src.height;
		var w = r * dst.height;
		if (dst.width >= w) {
			src.width = w;
			src.height = dst.height;
		} else {
			src.width = dst.width;
			src.height = dst.width / r;
		}
	} catch (e) {}
}

/**
 * 调整src高宽，类似css中的background-size: cover
 * @param {Size} src
 * @param {Size} dst
 */
export function cover(src, dst) {
	var r = src.width / src.height;
	var w = r * dst.height;
	if (dst.width > w) {
		src.width = dst.width;
		src.height = dst.width / r;
	} else {
		src.width = w;
		src.height = dst.height;
	}
}

export function sleep(ms) {
	return new Promise(function (resolve) {
		setTimeout(resolve, ms);
	});
}
export function limit(s, n) {
	return s ? (s.length <= n ? s : s.slice(0, n - 2) + "..") : "";
}

/**** 默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1 ****/
const CHARS = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678";
const NUMBERS = "0123456789";

/**
 * @param {number} len
 */
export function randomString(len) {
	var code = "";
	for (var i = 0; i < len; i++) {
		code += CHARS.charAt(Math.floor(Math.random() * CHARS.length));
	}
	return code;
}

/**
 * @param {number} len
 */
export function randomNumber(len) {
	var code = "";
	for (var i = 0; i < len; i++) {
		code += NUMBERS.charAt(Math.floor(Math.random() * NUMBERS.length));
	}
	return code;
}

/**
 * @param {number} max
 */
export function randN(max) {
	return Math.floor(Math.random() * max);
}

/**
 * @template T
 * @param {T|T[]} val
 * @returns {T[]}
 */
export function arr(val) {
	return val instanceof Array ? val : [val];
}

/**
 *
 * @param {any[]} list
 * @param {any[]} data
 * @param {string} key
 * @param {string} [foreignKey]
 */
export function leftJoin(list, data, key, foreignKey) {
	foreignKey = foreignKey || key + "_id";
	let map = {};
	for (let item of data) {
		map[item.id] = item;
	}
	for (let item of list) {
		let id = item[foreignKey];
		item[key] = map[id] || {id};
	}
}

/**
 * 修改body, 去掉keys和undefine
 * @template T
 * @param {T} body
 * @param {string[] | { [key: string]: any }} keys
 * @returns {T}
 */
export function clearKeys(body, keys) {
	if (keys instanceof Array) {
		// 清除keys中的字段
		for (let key of keys) {
			delete body[key];
		}
	} else {
		// 清除与keys值相同的字段
		for (let k in body) {
			let v = body[k];
			if (keys[k] == v || v === undefined) delete body[k];
		}
	}
	return body;
}

export function isEmpty(obj) {
	if (!obj) return true;
	let ok = true;
	for (let k in obj) {
		ok = false;
		break;
	}
	return ok;
}

const bs = ["B", "KB", "MB", "GB"];
/**
 * 字节数转换
 * @param {number} size
 * @param {number} [n=0] 保留几位小数
 * @param {number} [i=0] 从什么开始 b/kb/mb/gb
 * @returns
 */
export function traffic(size, n, i) {
	var sizeStandard = 1024;
	var ua = navigator.userAgent;
	if (~ua.indexOf("Mac")) sizeStandard = 1000;
	if (size == null) return "";
	size = parseInt(size);
	n = n || 0;
	for (i = i || 0; i < 4; i++) {
		if (size < sizeStandard) {
			if (999 > size && size >= 100) n = 0;
			else if (99 > size && size >= 10) n = 1;
			else if (10 > size && size >= 0) n = 2;
			size = (size * 1).toFixed(n);
			return size + bs[i];
		}
		size = size / sizeStandard;
	}
	return size + "GB";
}

/**
 * 字节数转换
 * @param {number} v
 * @param {number} [n=0] 保留几位小数 100为两位
 * @returns
 */
export function percent(v, n) {
	if (n == 0) return Math.floor(v * 100 * n) / n;
	else return (Math.floor(v * 100 * n) / n).toFixed(n / 10);
}

// 文件切片

export async function cutFile(file, chunkSize) {
	if (file.isStopCompress) return Promise.reject("stop");
	let res = fs.readFileSync(file.path);
	console.log(res);
	let array = res.buffer;
	res = array;
	let start = 0;
	let end;
	let fileSize = file.size;
	let filename = file.name;
	let chunks = Math.ceil(fileSize / chunkSize);
	let index = 0;
	while (start < fileSize) {
		end = start + chunkSize;
		if (end > fileSize) {
			end = fileSize;
		}
		let chunkData = res.slice(start, end);
		chunkData.name = filename;
		let are = {chunk: chunkData, chunks: chunks, name: filename, size: fileSize};
		file.chunksList.push({
			index: index,
			fileIndex: 0,
			name: are.name,
			size: are.size,
			chunk: are.chunk,
			chunks: are.chunks,
			chunkSize: 2048000,
		});
		index++;
		start = end;
	}
}

/**
 * 多文件切片
 * @param files
 * @param chunkSize
 * @returns {Array}
 */
export function cutFiles(files, chunkSize) {
	let chunksList = [];
	(function sliceNext(i) {
		if (i >= files.length) {
			return;
		}
		let file = files[i];
		let index = 0;
		cutFile(file, chunkSize, function (res) {
			chunksList.push({
				index: index,
				fileIndex: i,
				name: res.name,
				size: res.size,
				chunk: res.chunk,
				chunks: res.chunks,
				chunkSize: chunkSize,
			});
			index++;
		});
		sliceNext(i + 1);
	})(0);
	return chunksList;
}

export * from "./utils/webtool";
export * from "./utils/vuetool";
